import { Language } from '../../language/English';
import { API_WEBSITE_LOGOUT_URL } from '../../pages/Login/Api/loginConstants';
import { LoginService } from '../../pages/Login/Api/LoginService';
import { PAGE_LOGIN } from '../../PagesNames';
import Logger from '../Logger/Logger';
import Notification from '../Notification/Notification';
import WebsiteHttpService from '../WebsiteHttp/WebsiteHttpService';

export const callLogoutApi = async (
    dispatch: any,
    logoutAction: () => any,
    navigate: (url: string) => void,
) => {
    const notification = new Notification();
    const logger = new Logger();
    const websiteService = new WebsiteHttpService();
    const loginService = new LoginService();

    try {
        const response = await websiteService.get(API_WEBSITE_LOGOUT_URL, {});
        if (response && response.isRequestSuccessful) {
            try {
                const response = await loginService.get();
                if (response && response.isSuccess) {
                    dispatch(logoutAction());
                    try {
                        const cookies = document.cookie.split(';');
                        cookies.forEach((cookie) => {
                            const eqPos = cookie.indexOf('=');
                            const key =
                                eqPos > -1
                                    ? cookie.substr(0, eqPos).trim()
                                    : cookie.trim();
                            document.cookie = key + '=; Max-Age=0; path=/';
                            document.cookie =
                                key +
                                '=; Max-Age=0; path=/; domain=onlinedokument.ch';
                            document.cookie =
                                key +
                                '=; Max-Age=0; path=/; domain=.onlinedokument.ch';
                        });
                    } catch (e) {
                        logger.error(e);
                    }
                    navigate(PAGE_LOGIN);
                } else {
                    notification.error(Language.SOMETHING_IS_WRONG);
                }
            } catch (e) {
                logger.error(e);
            }
        }
    } catch (e) {
        logger.error(e);
    }
};
